import { newError, ERR_INVALID_STATE } from "../../utils/error";
import { loadContentAsBlobUrl } from "../../utils/dom";
import { joinPath } from "../../utils/string";
let gSpriteUrl = null;
export function getSpriteUrl() {
    if (gSpriteUrl == null) {
        throw newError(ERR_INVALID_STATE, "gSpriteUrl == null");
    }
    return (gSpriteUrl !== null && gSpriteUrl !== void 0 ? gSpriteUrl : "");
}
export async function prepareSprites(pDataPath) {
    if (gSpriteUrl == null) {
        const IsUnsupportedIOS = () => {
            //TODO: maybe create utils function for this
            if (/iP(hone|od|ad)/.test(navigator.platform)) {
                const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                if (v == null) {
                    return (false);
                }
                const tVersion = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || "0", 10)];
                return (tVersion[0] < 12 || (tVersion[0] === 12 && tVersion[1] < 2));
            }
            return (false);
        };
        const tSpritePath = joinPath(pDataPath, "cf/images/oap_sprite_v5.svg");
        if (IsUnsupportedIOS())
            gSpriteUrl = tSpritePath;
        else
            gSpriteUrl = await loadContentAsBlobUrl(tSpritePath);
    }
}
